const EMAIL_RE = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

export function isValidEmail(email: string): boolean {
  return EMAIL_RE.test(email.trim());
}

export function emailValidationMessage(label: string, email: string): string | null {
  const trimmed = email.trim();
  if (!trimmed) return `${label} is required.`;
  if (!isValidEmail(trimmed)) {
    return `${label} must be a valid email address (e.g. name@company.com.sg).`;
  }
  return null;
}
